export const LOAD_TIMEOUT_MS = 15000;

export class LoadTimeoutError extends Error {}

/** Bound reads that may otherwise wait indefinitely for a Firebase connection. */
export function withTimeout<T>(promise: Promise<T>, timeoutMs = LOAD_TIMEOUT_MS): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        const timer = setTimeout(() => reject(new LoadTimeoutError('Loading timed out. Please try again.')), timeoutMs);
        promise.then(resolve, reject).finally(() => clearTimeout(timer));
    });
}
